import type { ReturnPortalServicePointReturnRequestDto, ReturnPortalPickupRequest } from '@dhl/mdp-api'
import { toSenderDto, type ReturnRequest } from '~/model'

// Non-null assertion operators are used because validation already verified that required fields were specified
export const toPickupRequestDto = (returnRequest: ReturnRequest): ReturnPortalPickupRequest => {
  const { reference, returnType, pickupDate, pickupTimeWindowStart, pickupTimeWindowEnd, pallets, packages, captcha } =
    returnRequest
  return {
    sender: toSenderDto(returnRequest),
    description: reference,
    date: pickupDate!,
    timeSlot:
      returnType === 'consumer_pickup'
        ? {
            from: pickupTimeWindowStart!,
            to: pickupTimeWindowEnd!,
          }
        : undefined,
    pallets: pallets!,
    packages: packages!,
    captcha,
  }
}

// Non-null assertion operators are used because validation already verified that required fields were specified
export const toServicePointReturnRequestDto = (
  returnRequest: ReturnRequest
): ReturnPortalServicePointReturnRequestDto => {
  const { reference, captcha, packageSizeConfirmed } = returnRequest
  return {
    sender: toSenderDto(returnRequest),
    reference,
    captcha,
    packageSizeConfirmed: packageSizeConfirmed!,
    returnDeclarationMechanism: returnRequest.returnDeclarationMechanism || 'PrintedLabel',
  }
}
